<template>
    <v-row class="botones-compartir-indicador pa-2 px-6">
        <v-btn class="mx-2" text icon @click="copiarPortapapeles">
            <v-icon> fa-link </v-icon>
        </v-btn>
        <ShareNetwork
            v-for="enlace in enlacesCompartir"
            :key="enlace.enlace"
            :network="enlace.network"
            :url="direccionURLActual"
            :title="tituloIndicador"
            :description="indicador.definicion"
            :hashtags="listaHashtagsTexto"
        >
            <v-btn class="mx-2" text icon>
                <v-icon>
                    {{ enlace.icono }}
                </v-icon>
            </v-btn>
        </ShareNetwork>
        <v-spacer></v-spacer>
        <v-btn text icon @click="botonFavorito">
            <v-icon> {{ iconoFavorito }} </v-icon>
        </v-btn>
        <v-snackbar v-model="snackbar" color="#3a64ae" app>
            {{ mensajeSnackbar }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">
                    {{ $t("componentes.botones-compartir.cerrar") }}
                </v-btn>
            </template>
        </v-snackbar>
    </v-row>
</template>

<script>
export default {
    name: "BotonesCompartir",
    props: ["indicador"],
    data: () => ({
        enlacesCompartir: [
            { network: "twitter", icono: "fa-brands fa-twitter" },
            { network: "linkedin", icono: "fa-brands fa-linkedin" },
            { network: "whatsapp", icono: "fa-brands fa-whatsapp" },
        ],
        iconoFavorito: "fa-regular fa-bookmark",
        mensajeSnackbar: "",
        snackbar: false,
    }),
    computed: {
        listaFavoritos: {
            get: function () {
                return localStorage.listaFavoritos
                    ? JSON.parse(localStorage.listaFavoritos)
                    : [];
            },
        },

        existeIndicador() {
            return (
                this.indicador &&
                this.indicador.constructor === Object &&
                Object.keys(this.indicador).length !== 0
            );
        },
        direccionURLActual() {
            return window.location.href;
        },
        tituloIndicador() {
            return this.existeIndicador ? this.indicador.nombre : "";
        },
        listaHashtagsTexto() {
            return this.indicador.enlaces_hashtags
                ? this.indicador.enlaces_hashtags
                      .map((h) => h.hashtag.replace("#", ""))
                      .join(",") + ",ObservatorioUrbano"
                : "";
        },
    },
    methods: {
        copiarPortapapeles() {
            navigator.clipboard.writeText(this.direccionURLActual);
            this.mensajeSnackbar = this.$t(
                "componentes.botones-compartir.copiar-portapapeles"
            );
            this.snackbar = true;
        },

        botonFavorito() {
            if (!this.isConsentimientoCookies()) {
                this.snackbar = true;
                this.mensajeSnackbar = this.$t(
                    "componentes.botones-compartir.sin-consentimiento"
                );
                return;
            }

            let id = parseInt(this.indicador.id);
            let listaFavoritos = this.listaFavoritos;

            if (!listaFavoritos) {
                listaFavoritos = [id];
                this.mensajeSnackbar = this.$t("componentes.botones-compartir.anadido");
                this.iconoFavorito = "fa-solid fa-bookmark";
            } else {
                let posicionLista = listaFavoritos.indexOf(parseInt(id));
                if (posicionLista < 0) {
                    listaFavoritos.push(id);
                    this.mensajeSnackbar = this.$t(
                        "componentes.botones-compartir.anadido"
                    );
                    this.iconoFavorito = "fa-solid fa-bookmark";
                } else {
                    listaFavoritos.splice(posicionLista, 1);
                    this.mensajeSnackbar = this.$t(
                        "componentes.botones-compartir.eliminado"
                    );
                    this.iconoFavorito = "fa-regular fa-bookmark";
                }
            }
            this.snackbar = true;
            localStorage.listaFavoritos = JSON.stringify(listaFavoritos);
        },

        isConsentimientoCookies() {
            return document.cookie.split("; ").reduce((r, v) => {
                const parts = v.split("=");
                return parts[0] === this.nombreCookie
                    ? Boolean(Number(decodeURIComponent(parts[1])))
                    : r;
            }, false);
        },
    },

    mounted() {
        if (this.listaFavoritos.indexOf(parseInt(this.indicador.id)) < 0) {
            this.iconoFavorito = "fa-regular fa-bookmark";
        } else {
            this.iconoFavorito = "fa-solid fa-bookmark";
        }
    },
};
</script>
